// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"b_b","title":"b_c","paged":"b_d","description":"b_f","sectionTitle":"b_g","withDescription":"b_h"};